
export default {
  name: "IconChevronRight",
};
